/**
 * @generated SignedSource<<01245d62d7ca4c4d395e5c861e797fee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ApiKeyDeletionModalDeleteApiKeyMutation$variables = {
  apiKeyId: string;
};
export type ApiKeyDeletionModalDeleteApiKeyMutation$data = {
  readonly deleteApiKey: {
    readonly app: {
      readonly apiKeys: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  };
};
export type ApiKeyDeletionModalDeleteApiKeyMutation = {
  response: ApiKeyDeletionModalDeleteApiKeyMutation$data;
  variables: ApiKeyDeletionModalDeleteApiKeyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "apiKeyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "apiKeyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Apikey",
  "kind": "LinkedField",
  "name": "apiKeys",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ApiKeyDeletionModalDeleteApiKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Apikey",
        "kind": "LinkedField",
        "name": "deleteApiKey",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "app",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApiKeyDeletionModalDeleteApiKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Apikey",
        "kind": "LinkedField",
        "name": "deleteApiKey",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "app",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4055ba3066078abb9ad68ee7008e64f6",
    "id": null,
    "metadata": {},
    "name": "ApiKeyDeletionModalDeleteApiKeyMutation",
    "operationKind": "mutation",
    "text": "mutation ApiKeyDeletionModalDeleteApiKeyMutation(\n  $apiKeyId: ID!\n) {\n  deleteApiKey(id: $apiKeyId) {\n    app {\n      apiKeys {\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "36da276e1d5fdfe3f27e8ff7c4a7bebf";

export default node;
